function init_girlown_christmas(from_php){
    var main=$(".place.girlown"),special_event=from_php.special_event;
    function init_fightBox(){
        var box=main.find("#mainPVP");
        box.find(".myEye").myEye();
        var state=0,obj_border=main.find(".formSubmit.christmas .border");
        _moduleTimeHandler.add(function(){
            state=(state+1)%4;
            obj_border.attr("data-step",state);
        },100);
        
    }
    function init_infoBox(){
        var box=main.find(".book.christmasinfo");
        box.find(".myEye").myEye({step_max:23,interval:200});
        var arr=[0,7,1,8,2,9,3,10,4,11,5,12,6],flash=box.find(".flashCont .fl");
        var step=-1,step_max=16,dir=1,img_max=12;
        _moduleTimeHandler.add(function(){
            step+=dir;
            
            if(step<0){
                step=0;
                dir=1;
            }
            if(step==step_max){
                dir=-1;
            }
            if(step>img_max){
                if(step%2){
                    flash.removeClass("hide");
                }
                else{
                    flash.addClass("hide");
                }
            }
            else{
                var obj=flash.filter("[data-step='"+arr[step]+"']");
                if(dir==1){
                    obj.removeClass("hide");
                }
                else{
                    obj.addClass("hide");
                }
            }
        },150);
        _timerManager.addTimer(".place.girlown .endSpecialEventTimerJS",special_event.time_end,1);
    }
    function initChooseBox(){
        var book_choose=main.find(".book.christmasreward[g_id='1002']"),
        book_sure=main.find(".book.christmasreward[g_id='1003']");
        var girl_id=0;
        if(book_choose.length==0){
            return false;
        }
        book_sure.on("open",function(){
            book_sure.find(".textJS").html(
                connectVars(special_event.lang_choose,[$.takeGirlNameReal(girl_id)],"#")
            );
        });
        book_choose.find(".girlList .cell[data-girl_id]").click(function(){
            var th=$(this);
            girl_id=intval(th.attr("data-girl_id"));
            book_sure.find("input[name='giveSuitChristmas']").attr("value",th.attr("data-suit_id"));
            book_sure.bookUse("show");
            return false;
        });
        book_choose.find(".girlList").blankCell(5);
        
    //textJS
        
       
    }
    initChooseBox();
    init_fightBox();
    init_infoBox();
    main.find("#tvflash").qAnim({clips:3,width:461,loop:1,interval:350});
}